import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { DataDuKienDetailBaseOnBom, DataDuKienDetailCaculate, DuKienSanXuat, DuKienSanXuatNpl } from '../du-kien-san-xuat-model/du-kien-san-xuat.model';
const API_ROOT_URL = environment.ApiRoot + '/kehoach';

@Injectable()
export class DuKienSanXuatService {

	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});

	lastData$: BehaviorSubject<DuKienSanXuat[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }


	/*-------------------------------GET Method----------------------------- */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DuKienSanXuat_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataDMTK(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KeHoachMuaHang_List_KhongDuDinhMucTK', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getLSGiaoHang(Id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DuKienSanXuat_Get_HistoryGiaoHang?Id=${Id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getListNPL(item: DuKienSanXuat[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + '/DKSX_GetListNPL';
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
	calculateSLDeNghiMua(item: DuKienSanXuatNpl[]){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + '/DKSX_CalculateSLDeNghi';
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
	calculateSLBTPAfterChange(data: DataDuKienDetailCaculate){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + '/DKSX_CalculateSLBTP';
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */


	/*-------------------------------POST Method----------------------------- */
	add(item: DataDuKienDetailBaseOnBom): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/DuKienSanXuat_Insert', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */

}
